import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import theme from 'src/components/Core/Styles/theme'
import App from './App'
import './translations/init.ts'
import './index.css'
import { MsalProvider } from '@azure/msal-react'
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../authConfig/authConfig'
import { GlobalStyle } from 'src/components/Core/Styles/GlobalStyle'

const publicClientApplication: IPublicClientApplication = new PublicClientApplication(msalConfig)

createRoot(document.getElementById('root') as Element).render(
  <React.StrictMode>
    <MsalProvider instance={publicClientApplication}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </ MsalProvider>
  </React.StrictMode>
)
